module.exports = __webpack_public_path__ + "img/product_opdivo_logo.4827a62b.png";